<template>
  <li
    :class="{
      'mr-4 lg:mr-8': true,
    }"
  >
    <div
      :class="{
        'relative flex h-full': true,
      }"
    >
      <button
        v-if="title"
        type="button"
        :class="{
          'bg-transparent button-wrapper group whitespace-nowrap': true,
        }"
        aria-expanded="false"
        aria-haspopup="true"
        @click.stop="toggleActive(title)"
      >
        <span
          :class="{
            'whitespace-nowrap pr-10px text-13px font-bold uppercase leading-4 tracking-wider md:text-[11px] lg:text-13px': true,
            'hover:text-www-color-primary-lighter': true,
            'transition-all duration-300': true,
            'flex items-center gap-1 md:inline-block': true,
            'border-www-color-white after:block after:h-2 after:w-2 after:-rotate-[135deg] after:border-b-2 after:border-l-2 after:content-[\'\'] md:after:hidden': true,
          }"
          >{{ title }}</span
        >
        <div
          aria-hidden="true"
          :class="{
            'relative hidden h-[7px] w-3 cursor-pointer md:inline-block': true,
            'icon-wrapper': model == title,
          }"
        >
          <div
            :class="{
              'rotate-icon ease-[bezier(0.66, 0.66, 0.34, 1.00)] border-white bg-white inline-block h-6px w-[0.0938rem] origin-center -translate-x-[3px] rounded border-b-8 transition-all duration-[350ms] group-hover:text-www-color-primary-lighter motion-reduce:transition-none': true,
              [getRotationClass(title)]: true,
            }"
          ></div>
          <div
            :class="{
              'rotate-icon ease-[bezier(0.66, 0.66, 0.34, 1.00)] border-white bg-white inline-block h-6px w-[0.0938rem] origin-center rounded border-b-8 transition-all duration-[350ms] group-hover:text-www-color-primary-lighter motion-reduce:transition-none': true,
              [getMinusRotationClass(title)]: true,
            }"
          ></div>
        </div>
      </button>
    </div>
    <Transition name="slide">
      <SolutionMegaMenu
        v-show="model == title"
        :feature-data="latestBlogAsset || undefined"
        v-bind="props"
      />
    </Transition>
  </li>
</template>

<script setup lang="ts">
import type { SolutionsDropdown, CardBlogResult, InternalLinkRefQueryResult } from '~/sanity/types';
import { getCards } from '~/utils/solr/getCards';
import SolutionMegaMenu from './SolutionMegaMenu.vue';

const props = defineProps<SolutionsDropdown>();
const model = defineModel<string | null>({ default: null });
const latestBlogAsset = ref<CardBlogResult | null>(null);
const { getResolvedInternalLinkRef } = useRefsStore();
const viewAllLink = ref<InternalLinkRefQueryResult | null>(null);
const viewAllImageSrc = ref('');
const viewAllImage = await useStaticImage('view-all');
if (viewAllImage) {
  viewAllImageSrc.value = viewAllImage.cdnPathname;
}
provide('viewAllImageSrc', viewAllImageSrc.value);
if (props.viewAllButton?.value?.selectedPage) {
  viewAllLink.value = (
    await getResolvedInternalLinkRef(props.viewAllButton.value.selectedPage.reference._ref)
  ).value;
  provide('viewAllLink', {
    text: props.viewAllButton.text,
    link: viewAllLink.value,
  });
}

async function toggleActive(itemTitle: string) {
  if (model.value === itemTitle) {
    model.value = null;
  } else {
    model.value = itemTitle;
    // Fetch Latest Blog Asset on Toggle Dropdown Menu
    const { data: featureData } = await useSolrQuery<CardBlogResult>({
      q: getCards(['caseStudy']),
    });
    latestBlogAsset.value = featureData.value[0] ?? null;
  }
}

const getMinusRotationClass = (title: string) => {
  return model.value === title ? '-rotate-[45deg]' : '-rotate-[135deg]';
};

const getRotationClass = (title: string) => {
  return model.value === title ? 'rotate-[45deg]' : 'rotate-[135deg]';
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter-from,
.slide-leave-to {
  @media (max-width: 767px) {
    transform: translateX(100%);
  }
}
.icon-wrapper .rotate-icon {
  color: var(--www-color-primary-lighter);
}
</style>
